import '/assets/styles/layouts/_app.scss';
import classNames from 'classnames';

// Sections
import Header from '/views/sections/header';
import AppNav from '/views/sections/app-nav';

// Context
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';

const AppLayout = ({ children }) => {
	const { activeRoute } = useNavigator();
	return (
		<div className={classNames('app-layout', { 'has-nav': !activeRoute?.hideNav })}>
			<Header />
			{children}
			{!activeRoute?.hideNav && <AppNav />}
		</div>
	);
};

export default AppLayout;
